import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import { scrollIntoView } from '../../utilities/behavior-helpers/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import './main-categories-item.js';
import css_248z from './main-categories.scss.js';

const mainCategoriesItemSelector = 'main-categories-item';
const LitElementWithUtils = BaseWithUtils(s);
class MainCategories extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.itemWidth = 0;
        this.containerWidth = 0;
        this.itemCount = 0;
        this.items = null;
        this.isDesktop = false;
        this.query = '(max-width: 1365px)';
        this.handleWindowResize = () => {
            var _a, _b;
            const container = this.parentNode;
            this.containerWidth = container.clientWidth;
            if (((_a = this.nextElementSibling) === null || _a === void 0 ? void 0 : _a.tagName) === 'style'.toUpperCase())
                (_b = this.nextSibling) === null || _b === void 0 ? void 0 : _b.remove();
        };
    }
    handleTabKey(e, item) {
        if (e.key === 'Tab') {
            scrollIntoView(item, document.querySelector('.container > .top'), 50);
        }
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('resize', this.handleWindowResize);
        this.items = this.querySelectorAll(mainCategoriesItemSelector);
        this.itemCount = this.items.length;
        this.items.forEach((item, idx, array) => {
            item.addEventListener('keyup', e => this.handleTabKey(e, item));
            if (this.itemCount > 2)
                item.classList.add('divider');
            if (idx === array.length - 1) {
                // eslint-disable-next-line no-param-reassign
                item.style.border = 'none';
            }
        });
    }
    static getCategoryItemIndex(item) {
        return parseInt(item.getAttribute('index'), 10);
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.handleWindowResize);
        super.disconnectedCallback();
    }
    resetWidth() {
        if (this.nextElementSibling &&
            this.nextElementSibling.localName === 'style') {
            this.nextSibling.remove(); // del AdjacentHTML styles
        }
        this.itemWidth = 0;
    }
    handleMediaQuery(event) {
        this.isDesktop = !event.detail.value;
        this.requestUpdate();
        this.handleWindowResize();
        if (!this.isDesktop)
            this.resetWidth();
    }
    render() {
        return x `<div class="main-categories-wrapper ${this.itemCount > 2
            ? 'divider'
            : ''} ${this.utilityClasses}"><div class="main-categories ${this.rtl || isRTL() ? 'rtl' : ''}"><slot name="main-categories-item"></slot></div></div><lit-media-query .query="${this.query}" @changed="${this.handleMediaQuery}"></lit-media-query>`;
    }
}
MainCategories.styles = [LitElementWithUtils.styles || [], css_248z];
__decorate([
    n({ type: Boolean })
], MainCategories.prototype, "rtl", void 0);
__decorate([
    t()
], MainCategories.prototype, "itemWidth", void 0);
__decorate([
    t()
], MainCategories.prototype, "containerWidth", void 0);
__decorate([
    t()
], MainCategories.prototype, "itemCount", void 0);
__decorate([
    t()
], MainCategories.prototype, "items", void 0);
__decorate([
    t()
], MainCategories.prototype, "isDesktop", void 0);
customElements.define('main-categories', MainCategories);

export { MainCategories };
